import React, { Suspense } from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

const Page = React.lazy(() => import('./pages/Portfolio'));
const Error = React.lazy(() => import('./pages/Error'));
const Dinorun = React.lazy(() => import('./pages/games/Dinorun'));
const EscapeExtinction = React.lazy(() => import('./pages/games/EscapeExtinction'));
const BlockStack = React.lazy(() => import('./pages/games/BlockStack'));
const DragonMathBattle = React.lazy(() => import('./pages/games/DragonMathBattle'));

function App() {
  return (<>
    <Router>
      <Suspense fallback={
        <div className="loading-container">
          <span>Loading...</span>
        </div>
      }>
        <Switch>
          <Route path="/" exact component={Page} />
          <Route path="/games/dinorun" exact component={Dinorun} />
          <Route path="/games/escapeextinction" exact component={EscapeExtinction} />
          <Route path="/games/blockstack" exact component={BlockStack} />
          <Route path="/games/dragonmathbattle" exact component={DragonMathBattle} />
          <Route path="/error" exact component={Error} />
          <Redirect to="/error" />
        </Switch>
      </Suspense>
    </Router>
  </>);
}

export default App;
